import React from 'react';
import { format, getDay, setDay, addDays } from 'date-fns';
import { useState } from 'react';
import FileSaver from 'file-saver';
import FieldTable from '../../components/field-table';
import {Site, useSiteRevenueReportMutation} from "../../generated/graphql";
import {Button} from "@mui/material";
import {Close, Download} from "@mui/icons-material";
import {IsoDatePicker} from "../../components/IsoDatePicker";
import {ModalWindow} from "../../components/ModalWindow";
import { useToast } from "../../contexts/toast";

let today = new Date();
today = getDay(today) < 1 ? setDay(today, -5, { weekStartsOn: 1 }) : setDay(today, 1, { weekStartsOn: 1 })
const mondayString = format(today, 'yyyy-MM-dd');
const sundayString = format(addDays(today, 6), 'yyyy-MM-dd');

const columns = [
    {
        accessor: 'data.id',
        noSort: true,
        dataType:'selector'
    }, {
        accessor: 'name',
        header: 'Site Name',
        dataType:'default'
        // eslint-disable-next-line react/display-name
    }, {
        accessor: 'region.name',
        header: 'Region',
        dataType:'default'
}];

type RevenueReportModalArgs = {
    isOpen:boolean,
    values:Site[],
    doClose:()=>void
}


const RevenueReport = (props:RevenueReportModalArgs) => {
    const [selectedRows, setSelectedRows] = useState({});
    const [dateFromValue, setDateFromValue] = useState(mondayString);
    const [dateToValue, setDateToValue] = useState(sundayString);
    const [isWait, setWait] = useState(false);
    const [mutation] = useSiteRevenueReportMutation({ fetchPolicy: 'no-cache' });
    const { toast, dismiss } = useToast();
    function setDateFrom(evt) {
        setDateFromValue(evt.target.value);
    }
    function setDateTo(evt) {
        setDateToValue(evt.target.value);
    }
    async function submitForm() {
        if (isWait) return;
        if (!dateFromValue || !dateToValue) return;
        const selectedIds = [];
        Object.entries(selectedRows).forEach(function ([name, value]) {
            if (value) {
                selectedIds.push(name);
            }
        });
        if (!selectedIds.length) {
            toast('Please select sites before generating report',{variant:'error'});
            return;
        }
        if (dateToValue < dateFromValue) {
            toast('Date range invalid',{variant:'error'});
            return;
        }
        const genId = toast('Generating report',{variant:'info',timeout: 0});
        setWait(true);
        try {
            const data = await mutation({
                variables: {
                    dateFrom: dateFromValue,
                    dateTo: dateToValue,
                    selectedIds: selectedIds
                }
            });
            setWait(false);

            dismiss(genId);
            toast('Rendering file',{variant:'info'});
            const res = await fetch(data?.data?.siteRevenueReport?.reportData);
            const blobContent = await res.blob();
            //const blobUrl = URL.createObjectURL(blobContent);
            FileSaver.saveAs(blobContent, 'site-revenue-report-' + dateFromValue + '__' + dateToValue + '.xlsx');
            //window.open(blobUrl);
        } catch (e) {
            dismiss(genId);
            toast(e && e.graphqlErrors && e.graphqlErrors.length ? e.graphqlErrors[0].debugMessage : 'Download failed',{variant:'error'});
            setWait(false);
        }
    }
    let content = null, actions=null;
    if(props.isOpen) {
        actions =<>
            <Button color="primary" onClick={props.doClose} startIcon={<Close/>}>Close</Button>
            <Button color="primary" onClick={submitForm} startIcon={<Download/>}>Generate Report</Button>
        </>;
        content = (
            <>
                <div className="grid12">
                    <IsoDatePicker name="dateFrom" mondayOnly={true} value={dateFromValue}
                                   onChange={setDateFrom} label="Date Up From" className="grid12-6"/>
                    <IsoDatePicker name="dateTo" sundayOnly={true} value={dateToValue} onChange={setDateTo} label="Date Up to" className="grid12-6"/>
                </div>
                <h4>Sites</h4>
                    <FieldTable setSelectedRows={setSelectedRows}
                                selectedRows={selectedRows} hasDelete={false} values={props.values}
                                columns={columns} hasExport={false}/>
            </>);
    }
    return <ModalWindow isOpen={props.isOpen} onClose={props.doClose} header={"Site Revenue Report"} actions={actions} maxWidth="md">
        {content}
    </ModalWindow>;
}

export default RevenueReport;

